const REMEMBERED_LOGIN_EMAIL_KEY = "terramatrix_remembered_email";

function getLocalStorage(): Storage | null {
  return typeof window === "undefined" ? null : window.localStorage;
}

export function readRememberedLoginEmail(): string | null {
  try {
    const value = getLocalStorage()?.getItem(REMEMBERED_LOGIN_EMAIL_KEY);
    const email = value?.trim();
    return email ? email : null;
  } catch {
    return null;
  }
}

export function saveRememberedLoginEmail(email: string): void {
  const trimmedEmail = email.trim();
  if (!trimmedEmail) {
    clearRememberedLoginEmail();
    return;
  }

  try {
    getLocalStorage()?.setItem(REMEMBERED_LOGIN_EMAIL_KEY, trimmedEmail);
  } catch {
    // Remembered email is best-effort UI convenience.
  }
}

export function clearRememberedLoginEmail(): void {
  try {
    getLocalStorage()?.removeItem(REMEMBERED_LOGIN_EMAIL_KEY);
  } catch {
    // Remembered email is best-effort UI convenience.
  }
}
